import React from 'react';
import styles from '../danilo_serrano/danilo_serrano.module.scss';
import Perfil from './src/perfil.png';
import LinkPersonalizado7 from '../../components/LinkPersonalizado7/linkPersonalizado7.tsx';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';

const Danilo_serrano: React.FC = () => {

    return (
        <div className={styles.danilo_serrano}>
            <div className={styles["body-thunder"]}>
                <div className={`${styles["container-thunder"]}`} >
                    <img className={styles["img-perfil"]} src={Perfil} />
                    <div className={styles.links}>
                        <LinkPersonalizado7
                            href="https://www.instagram.com/danilo_serrano?utm_source=qr&igsh=MXVpNGNzeDZ2MXNiZQ=="
                            title="INSTAGRAM"
                            icon={<div style={{
                                width: "max-content",
                                backgroundColor: "#6b1524",
                                padding: "10px",
                                borderRadius: "100%",
                            }}><InstagramIcon height="32" color="#ffffff" /></div>}
                            colorText="#ffffff"
                        />
                        <LinkPersonalizado7
                            href="https://wa.me/551733122493?text=Olá, gostaria de mais informações"
                            title="WHATSAPP"
                            icon={<div style={{
                                width: "max-content",
                                backgroundColor: "#6b1524",
                                padding: "6px",
                                borderRadius: "100%",
                            }}><WhatsappIcon height="40" color="#ffffff" /></div>}
                            colorText="#ffffff"
                        />
                        <LinkPersonalizado7
                            href="https://maps.app.goo.gl/DEUJbKhX7J46AmqN7"
                            title="LOCALIZAÇÃO"
                            icon={<div style={{
                                width: "max-content",
                                backgroundColor: "#6b1524",
                                padding: "6px",
                                borderRadius: "100%",
                            }}><MapsIcon height="40" color="#ffffff" /></div>}
                            colorText="#ffffff"
                        />
                    </div>
                </div >
            </div >
        </div >
    );
};

export default Danilo_serrano;
